function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import OpenableComponent from '../OpenableComponent';
import ClickAway from '../ClickAway/ClickAway';
import FocusTrap from '../FocusTrap/FocusTrap';
import { classNamesFor } from '../utils/classNames';
var cx;
/**
 * DEPRECATED: Use SidePanel instead.
 *
 * The Drawer component creates a UI that can slide in an out of the screen to reveal
 * additional content or like dialogs give a user a place to focus in on and complete a task.
 * For example a users cart may appear as a drawer sliding out when they want to view or checkout.
 *
 * ## Related Components
 * - [UiLayers](../UiLayers/README.md)
 *
 * ## Composed of
 * - [ClickAway](../ClickAway/README.md)
 * - [FocusTrap](../FocusTrap/README.md)
 *
 * ## Usage
 *
 * ```
 * <Drawer>
 *    Drawer Content...
 * </Drawer>
 * ```
 *
 * ## Props
 */

var Drawer = /*#__PURE__*/function (_OpenableComponent) {
  _inherits(Drawer, _OpenableComponent);

  var _super = _createSuper(Drawer);

  function Drawer(props) {
    var _this;

    _classCallCheck(this, Drawer);

    _this = _super.call(this, props);
    _this._node = /*#__PURE__*/createRef();
    return _this;
  }

  _createClass(Drawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var openOnMount = this.props.openOnMount;

      if (openOnMount) {
        // without the timeout the transition does not run
        setTimeout(function () {
          return _this2.open();
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          qa = _this$props.qa;
      var isOpen = this.isOpen();

      var _Drawer$getClassName = Drawer.getClassName({
        isOpen: isOpen,
        className: className
      }),
          root = _Drawer$getClassName.root,
          drawer = _Drawer$getClassName.drawer;

      return /*#__PURE__*/React.createElement("div", {
        "data-qa": qa,
        className: root
      }, /*#__PURE__*/React.createElement(ClickAway, {
        node: this._node,
        onClickAway: this.close
      }, /*#__PURE__*/React.createElement(FocusTrap, {
        node: this._node,
        onEscape: this.close,
        trap: isOpen
      }, /*#__PURE__*/React.createElement("div", {
        ref: this._node,
        className: drawer,
        "aria-hidden": !isOpen
      }, children))));
    }
  }]);

  return Drawer;
}(OpenableComponent);

Drawer.getClassName = function (_ref) {
  var className = _ref.className,
      isOpen = _ref.isOpen;
  return {
    root: cx('psw-full-screen', 'psw-drawer-frame', isOpen && 'psw-is-open', className),
    drawer: cx('psw-drawer', 'psw-bg-1', 'psw-shadow-s', 'psw-fill-y', 'psw-top-right', 'psw-scroll-y')
  };
};

Drawer.useClassNames = function (classNames) {
  Drawer.classNames = classNames;
};

cx = classNamesFor(Drawer);
Drawer.defaultProps = {
  qa: '',
  className: '',
  isOpen: null,
  openOnMount: false,
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  children: null,
  closeDelay: 400
};
Drawer.propTypes = {
  /**
   * Custom classes to add for additional styling. This should not be needed.
   */
  className: PropTypes.string,

  /**
   * QA test identifier
   */
  qa: PropTypes.string,

  /**
   * To allow the component to be controlled, for use with UiLayers this is not needed
   */
  isOpen: PropTypes.bool,

  /**
   * To open the drawer when the component is mounted. This is needed when using the
   * drawer with UiLayers as the component will be mounted and unmounted once per open
   * close cycle
   */
  openOnMount: PropTypes.bool,

  /**
   * callback to be notified when the drawer is opened
   */
  onOpen: PropTypes.func,

  /**
   * callback to be notified when the drawer is closed
   */
  onClose: PropTypes.func,

  /**
   * The drawer contents
   */
  children: PropTypes.node,

  /**
   * The amount of time in milliseconds to wait before closing / unmounting the component
   */
  closeDelay: PropTypes.number
};
export default Drawer;